var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-ueditor-wrap',{key:_vm.ueditorKey,attrs:{"config":_vm.ueditorConfig,"destroy":true},on:{"ready":_vm.ready},model:{value:(_vm.dataModel),callback:function ($$v) {_vm.dataModel=$$v},expression:"dataModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }